import { StackScreenProps } from "@react-navigation/stack";
import { useFormContext } from "react-hook-form";
import { ProductFormValues } from "../../components/ProductForm/types";
import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { Uom } from "@towersystems/roam-common/lib/generated-types";

export type ProductSelectUomScreenProps = StackScreenProps<
  any,
  "ProductSelectUomScreen"
>;

export const ProductSelectUomScreen = ({
  navigation,
}: ProductSelectUomScreenProps) => {
  const { watch, setValue } = useFormContext<ProductFormValues>();

  const watchedUom = watch("UOM");

  const handleOnSelect = React.useCallback((uom: string) => {
    setValue("UOM", uom, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  return (
    <Page title="Select UOM">
      <FlatActionList
        items={[
          {
            key: "kg",
            title: "KG",
            onPress: () => handleOnSelect(Uom.KG),
            selected: watchedUom === Uom.KG,
          },
          {
            key: "g",
            title: "g",
            onPress: () => handleOnSelect(Uom.g),
            selected: watchedUom === Uom.g,
          },
        ]}
      />
    </Page>
  );
};
